enum ModalErrorStates {
	INACTIVE = 0,
	INVALID_CAMPAIGN_ID = 1,
	GET_GENERAL_CAMPAIGN_DATA = 2,
	GET_ACCOUNT_MANAGERS = 3,
	GET_CLIENT_SERVICES_PEOPLE = 4,
	SEARCH_ORGANISATIONS = 5,
	UNSUPPORTED_CAMPAIGN_SETTING = 6,
	GET_CUSTOM_PRODUCTS = 7,
	LOADING_GEOTARGETING_WHEN_STAND_ALONE = 8,
	GET_CAMPAIGN_READINESS_INFO = 9,
	GET_CAMPAIGN_LISTING_ENTITIES = 10,
	CUSTOM_PRODUCTS_ONLY_CAMPAIGN_PAGE_VIEW = 11,
	GET_RIGHTS_USERS = 12,
	SEARCH_RIGHTS_USERS = 13,
	GET_AUDITOR_ENTRIES = 14,
	GET_PRICING_PRODUCTS = 15,
	CREATE_FAILED_ON_DUPLICATE_ENTRY = 16,
	SAVE_FAILED_ON_DUPLICATE_ENTRY = 17,
	CUSTOM_PRODUCT_DATE_OUT_OF_BOUNDS = 18,
	SEARCH_CAMPAIGNS_FOR_IMPORT = 19,
	VALIDATE_IMPORT_ELIGIBILITY = 20,
	IMPORT_CAMPAIGN_CONFIGURATION = 21
}

enum ModalCustomProductStates {
	INACTIVE = 0,
	ADD_PRODUCT = 1,
	EDIT_PRODUCT = 2,
	DUPLICATE_PRODUCT = 3,
	DELETE_PRODUCT = 4
}

enum ModalUnsafeExitStates {
	INACTIVE = 0,
	EXITING = 1,
	SAVING = 2
}

export { ModalErrorStates, ModalCustomProductStates, ModalUnsafeExitStates };
